/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для попапа со списком товаров имеющих ограничения в корзине.
   */
  app.CheckoutRestrictedItemsPopupView = app.InfiniteScrollView.extend({
    el: '.restricted-goods-popup',
    events: {
      'click .js-leave-items': 'goToCheckout',
      'click .js-remove-items': 'removeItemsFromCart',
    },
    template: '#restricted-goods-popup-template',
    itemTemplate: '#restricted-goods-list-template',
    preventScroll: false,
    additionalOptions: ['mainWindow', 'bodyView', 'renderBillLoader', 'removeBillLoader'],

    /**
     * @inheritDoc
     */
    run: function () {
      this.restrictedItemsIds = [];
      this.isCartChanged = true;
      this.hasRestrictedItems = this.cart.cartInfo.has_restricted_items;
      this.template = app.helpers.TemplateHelper.getTemplate(this.template);
      this.itemTemplate = app.helpers.TemplateHelper.getTemplate(this.itemTemplate);
      this._initRestrictedItems();
      this._initPopup();
      this.initLoader();
      this.listenTo(this.restrictedItems, 'sync', this.updateItemList);
      this.listenTo(this.cart, 'sync', this.updateState);
      this.listenTo(this.cart, 'add updateQty addedCartByArticle removeCheckedFromCart destroy', this.updateState);
      this.listenTo(Backbone, 'bodyView:click', this.hidePopupOnClick);
    },

    /**
     * Инициализация прелоадера.
     */
    initLoader: function() {
      this.childViews.loader = new app.LoaderView({
        contentWrapper: this.$el.find('.list-container'),
        withFade: true,
        mainWindow: this.mainWindow,
        sizeClass: 'medium',
      });
    },

    /**
     * Удаляет прелоадер.
     */
    removeLoader: function () {
      this.childViews.loader.remove();
    },

    /**
     * Добавляет прелоадер.
     */
    renderLoader: function () {
      this.childViews.loader.render();
    },

    /**
     * Обновляет состояние флагов.
     */
    updateState: function () {
      this.isCartChanged = true;
      this.hasRestrictedItems = Boolean(this.cart && this.cart.cartInfo && this.cart.cartInfo.has_restricted_items);
    },

    /**
     * Инициализация коллекции товаров с ограничениями на доставку
     * @private
     */
    _initRestrictedItems: function () {
      this.restrictedItems = new app.Cart([], { settlement: this.settlement });
      this.restrictedItems.expand = 'restrictions,item';
      this.restrictedItems.hasRestrictions = 1;
      this.restrictedItems.isOnlyPositiveQty = 1;
      this.restrictedItems.settlementId = this.settlement.get('settlement_id');
    },

    /**
     * Инициализирует попап.
     */
    _initPopup: function () {
      app.InfiniteScrollView.prototype.initPopup.call(this);
      if (!this.$el.length) {
        var goodsList = this.fillItemTemplate(this.restrictedItems.models);
        this.setElement($(this.template({ restrictedGoodsList: goodsList, isCart: !!this.cart })));
        $('.popups').append(this.$el);
        this.popup = new als.Popup(this.$el, null, this.$('.js-popup-close'), 200);
      }
    },

    /**
     * Добавление списка товаров в попап.
     */
    fillItemList: function () {
      if (this.$el.length && this.restrictedItems.models.length) {
        var itemList = this.$('.popup-infinity-scroll-data');
        var items = this.restrictedItems.models;
        var goodsList = this.fillItemTemplate(items);
        itemList.html(goodsList);
      }
    },

    /**
     * Обновление списка товаров в попапе.
     */
    updateItemList: function () {
      this.removeLoader();
      var listedItems = this.$('.restricted-product'),
        itemList = this.$('.popup-infinity-scroll-data'),
        goodsList,
        items = {};
      if (listedItems.length && listedItems.length < this.restrictedItems.models.length) {
        items = this.restrictedItems.models.slice(listedItems.length);
        goodsList = this.fillItemTemplate(items);
        itemList.append(goodsList);
        this.preventScroll = false;
      }
    },

    /**
     * Создание списка товаров с ограничениями.
     * @param models
     * @returns {string}
     */
    fillItemTemplate: function (models) {
      var goodsList = '';
      _.each(models, (function (cartItem) {
        var restrictions = cartItem.get('restrictions'),
          restrict = false;
        if (
          restrictions.has_temperature_restriction
          || restrictions.has_settlement_restriction
        ) {
          restrict = true;
          this.restrictedItemsIds.push(cartItem.get('id'));
        }
        goodsList += this.itemTemplate({ model: cartItem.attributes, isRestricted: restrict });
      }).bind(this));
      return goodsList;
    },

    /**
     * Проверяет есть ли в корзине товары с ограничениями.
     * Ограничение на доставку некоторых товаров в Казахстан.
     * Ограничение на перевозку товаров с требованиями по температуре хранения
     */
  checkRestrictions: function () {
      if (this.popup && !this.popup.closed_) {
        return;
      }
      this.hasRestrictedItems = false;
      if (this.cart.cartInfo.has_restricted_items) {
        this.hasRestrictedItems = true;
        _.isFunction(this.renderBillLoader());
        if (this.isCartChanged) {
          this.getRestrictedItems();
        } else {
          this.show();
        }
        this.trigger('has_restricted_goods');
      }
    },

    /**
     * Заполнение коллекции товаров с ограничениями.
     */
    getRestrictedItems: function () {
      this.isCartChanged = false;
      this.preventScroll = false;
      this.restrictedItems.settlementId = this.settlement.get('settlement_id');
      this.restrictedItems.getFirstPage({
        fetch: true,
        reset: true,
        success: this.show.bind(this),
      });
    },

    /**
     * Организация бесконечного скролла
     */
    infiniteScroll: function () {
      var $infinityScrollData = this.$('.popup-infinity-scroll-data');
      var $scrollWindow = this.$('.scrollable');
      $scrollWindow.on('scroll', function () {
        // Проверяем пользователя, находится ли он в нижней части окна
        if (
          this.restrictedItems.mode === 'infinite'
          && !this.preventScroll
          && $scrollWindow.scrollTop() + $scrollWindow.height() >= $infinityScrollData.height() - 200
        ) {
          this.preventScroll = true;
          this.fetchScroll();
        }
      }.bind(this));
    },

    /**
     * Запрос новых моделей.
     */
    fetchScroll: function () {
      if (this.restrictedItems.state.currentPage < this.restrictedItems.state.lastPage && this.restrictedItems.hasNextPage()) {
        this.renderLoader();
        this.restrictedItems.getNextPage({
          remove: false,
          fetch: true,
        });
        this.restrictedItems.isScroll = true;
      }
    },

    /**
     * Удаляет товары выведенные в попап из корзины
     */
    removeItemsFromCart: function () {
      this.cart.deleteByItemsIds(this.restrictedItemsIds);
      this.listenToOnce(this.cart, 'sync', this.checkEmptyCart);
    },

    /**
     * Если есть товары в корзине переходим в оформление
     */
    checkEmptyCart: function () {
      if (this.cart.length) {
        this.goToCheckout();
      } else {
        this.close();
      }
    },

    /**
     * Отправляет на checkout
     */
    goToCheckout: function () {
      this.hasRestrictedItems = false;
      this.close();
      this.trigger('can_go_to_checkout');
    },

    /**
     * Показывает попап.
     */
    show: function () {
      this.restrictedItemsIds = [];
      this.fillItemList();
      this.infiniteScroll();
      if (this.popup && this.popup.closed_) {
        _.isFunction(this.removeBillLoader());
        this.popup.open();
      }
      this.$('.scrollable').scrollTop(0);
    },

    /**
     * Скрытие блока ограничения при транспортировке
     * @param {Event} e - событие клика
     */
    hidePopupOnClick: function (e) {
      var popup = this.el;
      if (popup) {
        var clickedOutside = !popup.contains(e.target);
        if (clickedOutside) {
          this.close();
        }
      }
    },

    /**
     * Скрывает попап.
     */
    close: function () {
      if (this.popup && !this.popup.closed_) {
        this.popup.close();
      }
    },
  });
})(jQuery);

}.call(window));